import React from 'react';
import clx from 'classnames';
import './HeaderFront.scss';
import { ContainerFront } from './ContainerFront';
import { Row, Col, Space, Grid } from 'antd';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';
import { useTranslation } from 'react-i18next';

export interface HeaderFrontProps {
  children: React.ReactNode;
  isAdminPreview?: boolean;
}

/**
 * Container della Header pagine pubbliche
 * Definisce la larghezza massima del contenuto della pagina.
 * Contiene i loghi superiori
 * Predisposto per ottenere come children il menu principale
 */
export function HeaderFront(props: HeaderFrontProps) {
  const { i18n } = useTranslation();
  // i18n.language; // it, en
  return (
    <div className={clx('header-front', i18n.language)}>
      <ContainerFront isHeader className="top-header-wrapper">
        <Row align="middle" className="header-logo-row">
          <Col className="logo-column" flex="auto">
            <Space size="middle" align="center">
              <div className="logo-main"></div>
              <div className="logo-app"></div>
            </Space>
          </Col>
          <Col className="institutional-column" flex="auto">
            <Space align="center">
              <div className="logo-institutional"></div>
            </Space>
          </Col>
        </Row>
      </ContainerFront>
      <div className="top-menu-line"></div>
      <ContainerFront isHeader>
        {props.isAdminPreview ? (
          <div className="top-menu-in-admin-preview">
            {props.children}
            <div className="top-menu-lock"></div>
          </div>
        ) : (
          props.children
        )}
      </ContainerFront>
    </div>
  );
}
